import React, { Component } from "react";
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Grid, Row, Col} from "react-bootstrap";
import {Card} from "../../components/Card/Card";
import {FormInputs} from "../../components/FormInputs/FormInputs";
import Button from "../../components/CustomButton/CustomButton";
import {updatePassword} from "../../actions/accountActions";

class UpdatePassword extends Component {

  constructor(props) {
    super(props);
    this.state = {
      password: "",
      repeatpassword: "",
      submit: false
    }
    this.handleUpdate = this.handleUpdate.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {

  }

  handleChange = event => {
    this.setState({
      [event.target.id]: event.target.value,
      submit: false
    }, () => {
      if (this.state.password.length >=6 &&
        this.state.repeatpassword.length >= 6 &&
        this.state.password === this.state.repeatpassword) {
        this.setState({submit: true});
      }
    });


  }

  handleUpdate() {
    console.log(this.state);
    const update = {
      password: this.state.password,
      repeatpassword: this.state.repeatpassword,
    }
    this.props.updatePassword(update);
  }

  render() {
    return (
      <div className="content">
        <Grid fluid>
          <Row>
            <Col md={8}>
              <Card
                title="Update Password"
                content={
                  <form>
                    <FormInputs
                      ncols={["col-md-6", "col-md-6"]}
                      proprieties={[
                        {
                          label: "password",
                          id: "password",
                          type: "password",
                          bsClass: "form-control",
                          placeholder: "Password",
                          onChange: this.handleChange,
                        },
                        {
                          label: "repeat password",
                          id: "repeatpassword",
                          type: "password",
                          bsClass: "form-control",
                          placeholder: "Repeat Password",
                          onChange: this.handleChange,
                        }
                      ]}
                    />
                  </form>
                }
                />
            </Col>
          </Row>
          <Row>
            <Col md={8}>
              <Button onClick={this.handleUpdate} bsStyle="info" pullRight fill type="submit" disabled={!this.state.submit} >
                Submit
              </Button>
            </Col>
          </Row>
        </Grid>
      </div>
    )
  }
}

UpdatePassword.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
  updatePassword: PropTypes.func.isRequired
}

const mapStateToProps = state => ({
  auth: state.auth,
  errors: state.errors
});

export default connect(mapStateToProps, {updatePassword})(UpdatePassword);






// WEBPACK FOOTER //
// ./src/views/Account/UpdatePassword.jsx